import * as React from 'react'
import { StyleSheet } from 'react-native'
import dayjs from 'dayjs'

import { useAppSelector } from '../../../hooks'
import { selectCalendar } from '../../../redux/selectors'
import { Calendar as DefaultCalendar } from 'react-native-calendars'
import { useThemeColor } from '../../../components/Themed'
import { DateData } from 'react-native-calendars/src/types'
import { PermissionStatus } from 'expo-modules-core';

import * as Notifications from 'expo-notifications';
import { Notification } from 'expo-notifications';
//import {Notifications} from 'react-native-notifications';
import { Sound } from 'expo-av/build/Audio'

interface Props {
  setManualEntryTimestamp: (value: number) => void
}

export default function Calendar({ setManualEntryTimestamp }: Props) {
  const calendar = useAppSelector(selectCalendar)
  const white = useThemeColor({}, 'white')
  const primary = useThemeColor({}, 'primary')
  const textColor = useThemeColor({}, 'text')
  const today = dayjs().format('YYYY-MM-DD')
  const markedDates = {
    [today]: {
      marked: true,
    },
    ...calendar,
  }

  const [notificationPermissions, setNotificationPermissions] = React.useState<PermissionStatus>(
    PermissionStatus.UNDETERMINED,
  );
  
  const requestNotificationPermissions = async () => {
    const { status } = await Notifications.requestPermissionsAsync();
    setNotificationPermissions(status);
    return status;
  };

  
  const handleNotification = (notification: Notification) => {
    const { title } = notification.request.content;
    console.warn(title);
  };
  
  const scheduleNotification = (seconds: number) => {
    const schedulingOptions = {
      content: {
        title: 'This is a notification',
        body: 'This is the body',
        sound: true,
        priority: Notifications.AndroidNotificationPriority.HIGH,
        color: '#4682B4'
        //sound: 'dj-shog---this-is-my-sound.wav', // <- for Android below 8.0
      },
      trigger: {
        seconds: seconds,
        channelId: 'lucid-scribe-alerts' // <- for Android 8.0+, see definition above
      },
    };
    Notifications.scheduleNotificationAsync(schedulingOptions);
  };
  
  
  React.useEffect(() => {
    return
    console.log("setup channel")

    
    requestNotificationPermissions();

    //console.log("requestPermissionsAsync", Notifications.requestPermissionsAsync())


    // Prepare the notification channel
Notifications.setNotificationChannelAsync('lucid-scribe-alerts', {
  name: 'Lucid Scribe notifications',
  importance: Notifications.AndroidImportance.HIGH,
  sound: 'dj-shog---this-is-my-sound.wav', // <- for Android 8.0+, see channelId property below
})

  }, []);

  React.useEffect(() => {
    if (notificationPermissions !== PermissionStatus.GRANTED) return;
    const listener = Notifications.addNotificationReceivedListener(handleNotification);
    return () => listener.remove();
  }, [notificationPermissions]);

  const onManualInput = ({ day, month, year }: DateData) => {
//https://wix.github.io/react-native-notifications/docs/getting-started
    console.log("scheduling")

    scheduleNotification(1)

   /* Notifications.postLocalNotification({
      title: "Local notification",
      body: "This notification was generated by the app!",
      extra: "data"
  })*/

    //Notifications.postLocalNotification({
   //   title: "Local notification",
  //    body: "This notification was generated by the app!"
    //sound: ""
    //badge: 0
    //type: ""
    //thread: ""
    //identifier: ""
    //payload: {}
// });

return 
/*
    console.log("scheduling")
// Eg. schedule the notification
 Notifications.scheduleNotificationAsync({
  content: {
    title: "You've got mail! 📬",
    body: 'Open the notification to read them all',
    sound: 'dj-shog---this-is-my-sound.wav', // <- for Android below 8.0
  },
  trigger: {
    seconds: 2,
    channelId: 'lucid-scribe-alerts', // <- for Android 8.0+, see definition above
  },
});
*/
console.log("scheduled")

return



    // DateObject months go from 1 to 12, Date months go from 0 to 11
    const newTimestamp = new Date(year, month - 1, day).getTime()

    if (newTimestamp < Date.now()) {
      setManualEntryTimestamp(newTimestamp)
    }
  }

  return (
    <DefaultCalendar
      style={styles.calendar}
      markedDates={markedDates}
      onDayPress={onManualInput}
      theme={{
        backgroundColor: white,
        calendarBackground: white,
        textSectionTitleColor: '#b6c1cd',
        selectedDayBackgroundColor: primary,
        selectedDayTextColor: white,
        todayTextColor: primary,
        dayTextColor: textColor,
        textDisabledColor: '#d9e1e8',
        dotColor: primary,
        selectedDotColor: white,
        arrowColor: textColor,
        monthTextColor: textColor,
        indicatorColor: 'blue',
        textDayFontWeight: '300',
        textMonthFontWeight: 'bold',
        textDayHeaderFontWeight: '300',
        textDayFontSize: 16,
        textMonthFontSize: 16,
        textDayHeaderFontSize: 16,
      }}
    />
  )
}

const styles = StyleSheet.create({
  calendar: {
    marginRight: 14,
    marginBottom: 16,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderRadius: 16
  },
})
